import IAppState from "../interfaces/IAppState";

export const appReducer = (state: IAppState, action: any) => {
    switch (action.type) {
        case "SET_THEME_VARIANT": return { ...state, isDarkTheme: action.isDarkTheme };
        case "SET_BGCOLOR": return { ...state, backgroundColor: action.color };
        case "SET_COLOR": return { ...state, color: action.color };
        case "SET_LOADER": return { ...state, showLoader: action.show };
        case "SET_REPORTS_GROUPPED": return { ...state, reportsGroupped: action.groupped };
        case "SET_ONLY_ACTIVE_REPORTS": return { ...state, onlyActiveReports: action.onlyActiveReports };
        case "SET_REPORT_FILTER": return { ...state, reportFilter: action.reportFilter };
        case "SET_REPORTS_QUERY": return { ...state, reportsQuery: action.query };
        case "SET_PROJECTS_QUERY": return { ...state, projectsQuery: action.query };
        case "SET_TASKS_QUERY": return { ...state, tasksQuery: action.query };
        default: return state;
    }
};
